<h1 mat-dialog-title>A Receber</h1>
<div mat-dialog-content class="full-width">  
    <div class="row">
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Id</mat-label>
                <input [(ngModel)]="data.aReceber.id" matInput readonly>
            </mat-form-field>
        </div>
        <div class="col-7">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Cliente</mat-label>
                <input [(ngModel)]="data.aReceber.name" matInput readonly>
            </mat-form-field>
        </div>  
        
        <div class="col-3">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Valor Total</mat-label>
                <input matInput currencyMask [(ngModel)]="data.aReceber.valor" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                 matInput readonly>
            </mat-form-field>
        </div>        
    </div>

    <div class="full-width">
        <section class="tabel-container mat-elevation-z8" tabindex="0">
            <table mat-table [dataSource]="listAreceberCliente" class="full-width">
                <!-- Coluna quantidade -->
                <ng-container matColumnDef="created">
                    <th mat-header-cell *matHeaderCellDef> Data </th>
                    <td mat-cell *matCellDef="let aReceber"> {{ aReceber.created | date : 'dd/MM/yyyy HH:mm'}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="product">
                    <th mat-header-cell *matHeaderCellDef>Produto</th>
                    <td mat-cell *matCellDef="let aReceber"> {{ aReceber.product }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Qtd</th>
                    <td mat-cell *matCellDef="let aReceber"> {{ aReceber.quantity }}
                    </td>
                </ng-container>

                <!-- Coluna preco -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Valor</th>
                    <td mat-cell *matCellDef="let aReceber"> {{ aReceber.amount | currency:'BRL'}}
                    </td>
                </ng-container> 
                
                <ng-container matColumnDef="amount_paid">
                    <th mat-header-cell *matHeaderCellDef>Valor Pago</th>
                    <td mat-cell *matCellDef="let aReceber"> {{ aReceber.amount_paid | currency:'BRL'}}
                    </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
            </table>
        </section>  
        <div class="row justify-content-between" style="padding: 15px;">
            <div class="col-12" align="right">
                <button (click)="openDialogPagamento(data.aReceber)" mat-raised-button style="color: #ffffff;background-color: #31aa53;">
                    <mat-icon>monetization_on</mat-icon>
                    Baixar
                </button>
            </div>
        </div>     
    </div>
</div>
